var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitor-attributes" } },
    [
      _vm.showEditModal
        ? _c(
            "Modal",
            {
              attrs: {
                "show-footer": "",
                "ok-text": "Güncelle",
                title: "Profil Bilgisini Düzenle",
                description: "Profil bilgisini düzenleyebilirsiniz.",
              },
              on: {
                cancel: function ($event) {
                  _vm.showEditModal = false
                },
                ok: function ($event) {
                  return _vm.updateAttribute()
                },
              },
            },
            [
              _c("VisitorAttributesForm", {
                attrs: { "initial-data": _vm.editingAttribute },
                on: {
                  input: function (data) {
                    return (_vm.editForm = data)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("a-alert", {
        attrs: {
          description: _vm.$t("settings.toInformDescription"),
          type: "info",
          "show-icon": "",
        },
      }),
      _vm._v(" "),
      _c(
        "a-table",
        {
          key: "attr-table",
          staticClass: "attr-table",
          attrs: {
            columns: _vm.columns,
            "data-source": _vm.getAttributes(),
            pagination: false,
          },
          scopedSlots: _vm._u([
            {
              key: "name",
              fn: function (text, record) {
                return _c(
                  "div",
                  {
                    key: "name",
                    staticStyle: { width: "100px" },
                    on: {
                      click: function ($event) {
                        _vm.editAttributeId = record._id
                        _vm.editAttributeValue = text
                      },
                      mouseleave: function ($event) {
                        _vm.editAttributeId = null
                      },
                    },
                  },
                  [
                    _vm.editAttributeId == record._id
                      ? _c(
                          "div",
                          [
                            _c("a-input", {
                              staticClass: "edit-input",
                              on: {
                                change: function ($event) {
                                  return _vm.updateAttributeName(
                                    record._id,
                                    _vm.editAttributeValue
                                  )
                                },
                              },
                              model: {
                                value: _vm.editAttributeValue,
                                callback: function ($$v) {
                                  _vm.editAttributeValue = $$v
                                },
                                expression: "editAttributeValue",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "attr-name" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" edit_note "),
                          ]),
                          _vm._v(" " + _vm._s(text)),
                        ]),
                  ]
                )
              },
            },
            {
              key: "visible",
              fn: function (text, record) {
                return _c(
                  "span",
                  {},
                  [
                    _c("a-switch", {
                      staticClass: "md-warning ml-3",
                      attrs: { name: "writing" },
                      on: {
                        change: function ($event) {
                          return _vm.updateAttrVisible(record._id, text)
                        },
                      },
                      model: {
                        value: record.visible,
                        callback: function ($$v) {
                          _vm.$set(record, "visible", $$v)
                        },
                        expression: "record.visible",
                      },
                    }),
                  ],
                  1
                )
              },
            },
            {
              key: "process",
              fn: function (text, record) {
                return _c(
                  "div",
                  { key: "process", staticClass: "action-buttons" },
                  [
                    _c("SupsisButton", {
                      staticClass: "process-button",
                      attrs: { icon: "edit" },
                      on: {
                        click: function ($event) {
                          return _vm.editAttribute(record)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("SupsisButton", {
                      staticClass: "process-button",
                      attrs: { danger: "", icon: "delete" },
                      on: {
                        click: function ($event) {
                          return _vm.deleteAttribute(record._id)
                        },
                      },
                    }),
                  ],
                  1
                )
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "span",
            {
              key: "usingVisitor",
              attrs: { slot: "usingVisitor" },
              slot: "usingVisitor",
            },
            [
              _c("SupsisButton", { attrs: { disabled: true } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("settings.showVisitor")) +
                    "\n            "
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }